
import "./activity.scss";
import { PiPlayFill, PiPlayBold } from "react-icons/pi";
import { GoTrash, GoBookmarkFill } from "react-icons/go";
import { ActivitiesService } from "services/activities.service"
import { useWebsocketsService } from "hook/useWebsockets";
import { type activityType } from "models/activity.model";
import { CoursesService } from "services/courses.service";
import { courseTypes, type courseType } from "models/course.model";
import { useTranslation } from "react-i18next";
import { getMappedStatus, StatusActivity } from "utils/activity.util";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import type { ModalType } from "parts/modal/modal";
import { sanitizeId } from "utils/modal.util";
import { images } from 'assets';
import { useLocation, useNavigate } from "react-router-dom";


export default function Activity({ activity, deleteActivity, onClose }: { activity: activityType | courseType, deleteActivity?: (activity: activityType) => void, onClose?: () => void }) {
  const { t } = useTranslation();
  const { runActivity } = useWebsocketsService();
  const activityService = new ActivitiesService(runActivity);
  const courseService = new CoursesService();
  const activitySrcPath = activity.imageSrc?.trim() ? activity.imageSrc : images['activityDefault'];
  const [isActivityHovered, setIsActivityHovered] = useState<boolean>(false);
  const wrapperRef = useRef<HTMLLIElement>(null);
  const status = getMappedStatus(activity.status?.toLowerCase() ?? "");
  const modal: ModalType = useSelector((state: any) => state.modal);
  const navigate = useNavigate();
  const location = useLocation();
  let currentPath = location.pathname;
  if (currentPath === '/' || currentPath === '') {
    currentPath = '';
  }

  function downloadActivity(): void {
    // #todo download and unzip module from tac
  }

  const formatAuthor = (fullName: string) => {
    const parts = fullName.trim().split(" ");
    if (parts.length < 2) return fullName;
    
    const firstName = parts[0];
    const lastName = parts.slice(1).join(" ");
    
    return `${firstName[0]}. ${lastName}`;
  }

  const handleBlur = () => {
    requestAnimationFrame(() => {
      if (wrapperRef.current && !wrapperRef.current.contains(document.activeElement)) {
        setIsActivityHovered(false);
      }
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLLIElement | SVGElement>, who: string) => {
    if (e.key === 'Enter' || e.key === ' ') {
      switch (who) {
        case "hoverActivity":
          setIsActivityHovered(true);
          break;
        case "deleteActivity":
          deleteActivity?.(activity as activityType);
          break;
        case "playActivity":
          activityService.launchActivity(activity as activityType, onClose)
          break;
        case "openCourse":
          navigate(`${location.pathname}/course`, { state: { course: activity as courseType, from: currentPath } });
          break;
        case "downloadActivity":
          downloadActivity();
          break;

      }
      e.preventDefault();
      setIsActivityHovered(true);
    }
  };

  return (
    <li
      ref={wrapperRef}
      className={`activity ${isActivityHovered ? 'hovered' : ''}`}
      tabIndex={0}
      onKeyDown={(e) => handleKeyDown(e, "hoverActivity")}
      onBlur={handleBlur}
    >
      {(courseTypes.includes(activity.type ?? "") || status === StatusActivity.PENDING) && activity.sessionId &&
        <div className={`activity_badge ${status}`}>
          <span>{t(status)}</span>
        </div>
      }
      <div className="activity_image">
        <span className="activity_tooltip">
          {activity.offline && deleteActivity &&
            <GoTrash
              tabIndex={isActivityHovered ? 0 : -1}
              role="button"
              aria-label={t("button_delete_downloaded_activity")}
              aria-haspopup="dialog"
              aria-expanded={modal.isModalOpen}
              aria-controls={sanitizeId(t("delete_activity"))}
              onClick={() => deleteActivity(activity as activityType)}
              onKeyDown={(e) => handleKeyDown(e, "deleteActivity")} />
          }
          {activity.type !== "COURSE" &&
            <PiPlayFill
              tabIndex={isActivityHovered ? 0 : -1}
              role="button"
              aria-label={t("button_run_activity")}
              onClick={() => activityService.launchActivity(activity as activityType, onClose)}
              onKeyDown={(e) => handleKeyDown(e, "playActivity")} />
          }
          {activity.type === "COURSE" &&
            <PiPlayBold
              tabIndex={isActivityHovered ? 0 : -1}
              role="link"
              aria-label={t("button_open_course")}
              onClick={() => navigate(`${currentPath}/course`, { state: { course: activity as courseType, from: currentPath } })}
              onKeyDown={(e) => handleKeyDown(e, "openCourse")} />
          }
          {/* {!activity.offline && activity.status?.toLowerCase() !== StatusActivity.FINISHED && 
            <LiaCloudDownloadAltSolid 
              tabIndex={isActivityHovered ? 0 : -1} 
              role="button" 
              aria-label={t("button_download_activity")}
              onClick={downloadActivity} 
              onKeyDown={(e) => handleKeyDown(e, "downloadActivity")}/>
          } */}
        </span>
        <img src={activitySrcPath} alt={activity.title}></img>
      </div>
      <div className="activity_footer">
        {activity.collectionName && <p className="activity_footer__collection-name">{activity.collectionName}</p>}
        <p className="activity_footer__title">{activity.title}</p>
        {activity.sessionCreatedBy && <span className="activity_footer__created-by">{formatAuthor(activity.sessionCreatedBy)}</span>}
        {activity.date && <span className="activity_footer__date">{activity.date}</span>}
      </div>
    </li>
  );
}


